<div class="tw-bg-white">
  <div class="tw-font-inter tw-rounded-xl tw-bg-white tw-px-7 tw-py-4 max-md:tw-px-4">
    <div class="tw-pb-3.5 tw-border-b tw-border-solid tw-border-gray-200">
      <div class="tw-font-inter tw-font-bold tw-text-xl max-md:tw-text-lg tw-text-gray-700 tw-mb-4 max-md:tw-mb-3">Event timings</div>

      <div class="tw-flex tw-flex-col tw-gap-2 md:tw-flex-row md:tw-items-center md:tw-justify-between md:tw-gap-3">
        <div class="tw-flex tw-items-center tw-gap-3 max-md:tw-gap-2 md:tw-gap-4 tw-flex-wrap tw-min-w-0">
          <div class="tw-flex tw-items-center tw-gap-2 max-md:tw-gap-1.5 md:tw-gap-2.5 tw-min-w-0">
            @if (publicStartDate(); as start) {
              <div
                class="tw-min-w-11 max-md:tw-min-w-9 tw-bg-gray-50 max-md:tw-py-0.5 tw-py-1 tw-px-2 tw-border tw-border-gray-200 tw-rounded-lg tw-flex tw-flex-col tw-items-center tw-justify-center"
              >
                <div class="tw-text-xs tw-font-inter tw-text-gray-400">{{ start | date: 'EEE': timezone() }}</div>
                <div class="tw-font-bold tw-text-base max-md:tw-text-sm tw-text-black tw-font-inter">{{ start | date: 'd': timezone() }}</div>
              </div>
              <div
                class="tw-font-inter tw-font-medium tw-text-lg max-md:tw-text-xs tw-text-black tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-min-w-0"
              >
                <span class="max-md:tw-hidden">{{ start | date: 'MMMM, y, HH:mm': timezone() }}</span>
                <span class="md:tw-hidden">{{ start | date: 'MMM, y, HH:mm': timezone() }}</span>
              </div>
            }
          </div>

          <div class="event-timings-header-separator tw-font-inter tw-font-semibold tw-opacity-80 tw-text-sm max-md:tw-text-xs">—</div>

          <div class="tw-flex tw-items-center tw-gap-2 max-md:tw-gap-1.5 md:tw-gap-2.5 tw-min-w-0">
            @if (publicEndDate(); as end) {
              <div
                class="tw-min-w-11 max-md:tw-min-w-9 tw-bg-gray-50 max-md:tw-py-0.5 tw-py-1 tw-px-2 tw-border tw-border-gray-200 tw-rounded-lg tw-flex tw-flex-col tw-items-center tw-justify-center"
              >
                <div class="tw-text-xs tw-font-inter tw-text-gray-400">{{ end | date: 'EEE': timezone() }}</div>
                <div class="tw-font-bold tw-text-base max-md:tw-text-sm tw-text-black tw-font-inter">{{ end | date: 'd': timezone() }}</div>
              </div>
              <div
                class="tw-font-inter tw-font-medium tw-text-lg max-md:tw-text-xs tw-text-black tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-min-w-0"
              >
                <span class="max-md:tw-hidden">{{ end | date: 'MMMM, y, HH:mm': timezone() }}</span>
                <span class="md:tw-hidden">{{ end | date: 'MMM, y, HH:mm': timezone() }}</span>
              </div>
            }
          </div>
        </div>

        @if (timezoneGmtLabel(); as gmt) {
          <span
            class="tw-font-inter tw-font-medium tw-text-xl max-md:tw-text-sm tw-text-black tw-whitespace-nowrap max-md:tw-self-start md:tw-shrink-0"
          >{{ gmt }}</span>
        }
      </div>
    </div>

    <div class="tw-pt-3.5 tw-min-h-0 tw-overflow-y-auto tw-flex tw-flex-col tw-gap-3">
      @for (row of displayedTimings(); track $index) {
        <div
          class="day-row tw-grid tw-grid-cols-[84px_1fr] tw-gap-3.5 tw-items-stretch max-md:tw-grid-cols-[78px_1fr] max-md:tw-gap-2.5"
          [attr.role]="row.state === eventTimingStatus.INACTIVE ? 'group' : null"
          [attr.aria-disabled]="row.state === eventTimingStatus.INACTIVE ? 'true' : null"
        >
          <div
            class="tw-font-inter tw-rounded-lg tw-p-2 tw-flex tw-flex-col tw-justify-center"
            [ngClass]="{
              'tw-bg-blue-600 tw-text-white': row.state === eventTimingStatus.ACTIVE && row.slots.length > 0,
              'tw-bg-gray-200 tw-text-gray-500': row.state === eventTimingStatus.INACTIVE || row.slots.length === 0
            }"
          >
            @if (row.start_datetime) {
              <div class="tw-text-inherit tw-font-bold tw-text-base max-md:tw-text-sm tw-font-inter">
                {{ row.start_datetime | date: 'EEE': timezone() }}
              </div>
              <div class="tw-text-inherit tw-text-base max-md:tw-text-sm tw-font-inter">
                {{ row.start_datetime | date: 'MMM d': timezone() }}
              </div>
            } @else {
              <div class="tw-text-inherit tw-text-sm max-md:tw-text-xs tw-font-inter">—</div>
            }
          </div>

          <div
            class="tw-font-inter tw-px-6 max-md:tw-px-4 tw-py-2 tw-min-h-16 tw-bg-gray-100 tw-rounded-lg tw-w-full tw-flex tw-flex-col tw-justify-center"
            [class.tw-bg-gray-200]="row.state === eventTimingStatus.INACTIVE || row.slots.length === 0"
          >
            @if (row.state === eventTimingStatus.INACTIVE) {
              <div class="tw-italic tw-font-inter tw-text-base max-md:tw-text-sm tw-text-gray-500">No event scheduled on this day</div>
              @if (row.info?.trim() !== '') {
                <div class="tw-italic tw-font-inter tw-text-base max-md:tw-text-sm tw-text-gray-500 tw-mt-1">{{ row.info }}</div>
              }
            } @else if (row.slots.length > 0) {
              <div
                class="tw-flex tw-gap-1 tw-items-start tw-font-medium tw-text-base max-md:tw-text-sm md:tw-flex-wrap md:tw-items-center md:tw-gap-0 md:tw-overflow-x-auto md:tw-whitespace-nowrap tw-flex-wrap"
              >
                @for (slot of row.slots; track $index + slot.from + slot.to) {
                  <div class="tw-flex tw-items-center tw-flex-nowrap">
                    <span class="tw-whitespace-nowrap tw-shrink-0 tw-text-base max-md:tw-text-sm tw-font-inter tw-text-black">
                      {{ slot.from }}
                      @if (slot.to && slot.to !== slot.from) {
                        - {{ slot.to }}
                      }
                    </span>
                    @if (!$last) {
                      <span
                        class="tw-inline-block tw-h-6 tw-border-l tw-border-gray-400 tw-mx-3 tw-shrink-0"
                        aria-hidden="true"
                      ></span>
                    }
                  </div>
                }
              </div>
              @if (row.info?.trim() !== '') {
                <div class="tw-italic tw-font-inter tw-text-base max-md:tw-text-sm tw-text-gray-500 tw-mt-1">{{ row.info }}</div>
              }
            } @else {
              <div class="tw-italic tw-font-inter tw-text-base max-md:tw-text-sm tw-text-gray-500">No event activity on this day</div>
            }
          </div>
        </div>
      }
    </div>

    <div class="tw-flex tw-justify-between tw-items-center mt-1">
      <div>
        @if (showTimingsToggle()) {
          <button
            type="button"
            class="tw-font-inter tw-font-semibold tw-text-sm max-md:tw-text-xs tw-text-blue-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-self-start"
            (click)="toggleTimingsExpanded()"
          >
            @if (isTimingsExpanded()) {
              Show less
            } @else {
              + {{ hiddenTimingsCount() }} more days
            }
          </button>
        }
      </div>
      @if (addToCalendarUrl(); as calUrl) {
        <div class="tw-flex tw-justify-end tw-items-center tw-pt-2.5">
          <a
            class="tw-text-blue-600 tw-font-inter tw-font-semibold tw-text-sm max-md:tw-text-xs tw-no-underline tw-inline-flex tw-items-center tw-gap-1.5 tw-shrink-0"
            [href]="calUrl"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 14.4C0 14.8243 0.168571 15.2313 0.468629 15.5314C0.768687 15.8314 1.17565 16 1.6 16H14.4C14.8243 16 15.2313 15.8314 15.5314 15.5314C15.8314 15.2313 16 14.8243 16 14.4V6.4H0V14.4ZM11.2 8.4C11.2 8.29391 11.2421 8.19217 11.3172 8.11716C11.3922 8.04214 11.4939 8 11.6 8H12.4C12.5061 8 12.6078 8.04214 12.6828 8.11716C12.7579 8.19217 12.8 8.29391 12.8 8.4V9.2C12.8 9.30609 12.7579 9.40783 12.6828 9.48284C12.6078 9.55786 12.5061 9.6 12.4 9.6H11.6C11.4939 9.6 11.3922 9.55786 11.3172 9.48284C11.2421 9.40783 11.2 9.30609 11.2 9.2V8.4ZM11.2 11.6C11.2 11.4939 11.2421 11.3922 11.3172 11.3172C11.3922 11.2421 11.4939 11.2 11.6 11.2H12.4C12.5061 11.2 12.6078 11.2421 12.6828 11.3172C12.7579 11.3922 12.8 11.4939 12.8 11.6V12.4C12.8 12.5061 12.7579 12.6078 12.6828 12.6828C12.6078 12.7579 12.5061 12.8 12.4 12.8H11.6C11.4939 12.8 11.3922 12.7579 11.3172 12.6828C11.2421 12.6078 11.2 12.5061 11.2 12.4V11.6ZM7.2 8.4C7.2 8.29391 7.24214 8.19217 7.31716 8.11716C7.39217 8.04214 7.49391 8 7.6 8H8.4C8.50609 8 8.60783 8.04214 8.68284 8.11716C8.75786 8.19217 8.8 8.29391 8.8 8.4V9.2C8.8 9.30609 8.75786 9.40783 8.68284 9.48284C8.60783 9.55786 8.50609 9.6 8.4 9.6H7.6C7.49391 9.6 7.39217 9.55786 7.31716 9.48284C7.24214 9.40783 7.2 9.30609 7.2 9.2V8.4ZM7.2 11.6C7.2 11.4939 7.24214 11.3922 7.31716 11.3172C7.39217 11.2421 7.49391 11.2 7.6 11.2H8.4C8.50609 11.2 8.60783 11.2421 8.68284 11.3172C8.75786 11.3922 8.8 11.4939 8.8 11.6V12.4C8.8 12.5061 8.75786 12.6078 8.68284 12.6828C8.60783 12.7579 8.50609 12.8 8.4 12.8H7.6C7.49391 12.8 7.39217 12.7579 7.31716 12.6828C7.24214 12.6078 7.2 12.5061 7.2 12.4V11.6ZM3.2 8.4C3.2 8.29391 3.24214 8.19217 3.31716 8.11716C3.39217 8.04214 3.49391 8 3.6 8H4.4C4.50609 8 4.60783 8.04214 4.68284 8.11716C4.75786 8.19217 4.8 8.29391 4.8 8.4V9.2C4.8 9.30609 4.75786 9.40783 4.68284 9.48284C4.60783 9.55786 4.50609 9.6 4.4 9.6H3.6C3.49391 9.6 3.39217 9.55786 3.31716 9.48284C3.24214 9.40783 3.2 9.30609 3.2 9.2V8.4ZM3.2 11.6C3.2 11.4939 3.24214 11.3922 3.31716 11.3172C3.39217 11.2421 3.49391 11.2 3.6 11.2H4.4C4.50609 11.2 4.60783 11.2421 4.68284 11.3172C4.75786 11.3922 4.8 11.4939 4.8 11.6V12.4C4.8 12.5061 4.75786 12.6078 4.68284 12.6828C4.60783 12.7579 4.50609 12.8 4.4 12.8H3.6C3.49391 12.8 3.39217 12.7579 3.31716 12.6828C3.24214 12.6078 3.2 12.5061 3.2 12.4V11.6Z"
                fill="#1C64F2"
              />
              <path
                d="M16 3.2C16 2.77565 15.8314 2.36869 15.5314 2.06863C15.2313 1.76857 14.8243 1.6 14.4 1.6H12.8V0.8C12.8 0.587827 12.7157 0.384344 12.5657 0.234315C12.4157 0.0842854 12.2122 0 12 0C11.7878 0 11.5843 0.0842854 11.4343 0.234315C11.2843 0.384344 11.2 0.587827 11.2 0.8V1.6H8.8V0.8C8.8 0.587827 8.71571 0.384344 8.56569 0.234315C8.41566 0.0842854 8.21217 0 8 0C7.78783 0 7.58434 0.0842854 7.43431 0.234315C7.28429 0.384344 7.2 0.587827 7.2 0.8V1.6H4.8V0.8C4.8 0.587827 4.71571 0.384344 4.56569 0.234315C4.41566 0.0842854 4.21217 0 4 0C3.78783 0 3.58434 0.0842854 3.43431 0.234315C3.28429 0.384344 3.2 0.587827 3.2 0.8V1.6H1.6C1.17565 1.6 0.768687 1.76857 0.468629 2.06863C0.168571 2.36869 0 2.77565 0 3.2V4.8H16V3.2Z"
                fill="#1C64F2"
              />
            </svg>
            Add to Calendar
          </a>
        </div>
      }
    </div>
  </div>
</div>
